export const colors = {
  default: '#2699FB',
  danger: '#FF2424',
  success: '#33AC2E',
  warning: '#FFB324',
  grey: '#6B7786',
  white: '#fff',
};
